<template>
  <div>
    <page-header
      :actions="headerActionsConfig"
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
    />
    <div class="row d-flex flex-row-reverse">
      <div class="col-3">
        <div class="p-4 bg-secondary-1 rounded">
          <custom-input
            id="search"
            label-class="custom-modal-label"
            type="text"
            v-model="searchText"
            icon="fas fa-search text-orange"
            placeholder="Escriba nombre del Dashboard"
            left-icon
          />
        </div>
      </div>
    </div>
    <custom-separator class="mb-4 mt-5" text="Resultados de Dashboard" />
    <div class="row">
      <div class="col-12">
        <custom-result-not-found v-if="items.length == 0" />
        <div v-else>
          <result-row
            v-for="item in items"
            :key="item.id"
            :item="item"
            @update="updateHandler"
          />
        </div>
        <pagination
          v-if="
            paginationModel.totalItemCount > paginationModel.perPage &&
            searchText.length == 0
          "
          :data="paginationModel"
          show-text
          @pagination-go-page="search($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DashboardsSourcesUpdateService from '@/services/api/dashboardsSourcesUpdate.api'
import PageHeader from 'PageHeader'
import CustomInput from '@/components/common/form/CustomInput'
import CustomSeparator from 'custom-separator'
import CustomResultNotFound from 'custom-result-not-found'
import Pagination from 'pagination'
import ResultRow from './components/ResultRow'
import hubservice from '@/services/api/hub/hubservice.js'
import Vue from 'vue'
import loadControlStatus from '@/utils/constants/loadControlStatus.js'

const PAGE_SIZE = 10
const PAGE_INDEX = 1

export default {
  name: 'DashboardSourcesMain',
  components: {
    PageHeader,
    CustomInput,
    CustomSeparator,
    CustomResultNotFound,
    Pagination,
    ResultRow,
  },
  data() {
    return {
      searchText: '',
      results: [],
      paginationModel: {
        perPage: PAGE_SIZE,
        currentPage: PAGE_INDEX,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
    }
  },
  computed: {
    headerConfig() {
      return {
        title: 'Actualización de Fuentes de Dashboards',
        icon: 'fas fa-user-chart',
        routes: [
          'Inicio',
          'Dashboard',
          'Actualización de Fuentes de Dashboards',
        ],
      }
    },
    headerActionsConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left pr-2',
          variant: 'outline-success ml-0',
          click: () => this.$router.push('/dashboard'),
        },
      ]
    },
    items() {
      const list = this.results ? this.results : []
      let items = this.searchText
        ? list.filter((e) =>
            e.name.toLowerCase().match(this.searchText.toLowerCase())
          )
        : list
      return items
    },
  },
  mounted() {
    this.search()
  },
  created() {
    Vue.use(hubservice)
    this.$userHub.$on(
      'hub-recieve-status-updated-dashboard',
      this.updateQueueStatusByhub
    )

    /* eslint-disable no-debugger, no-console */
    console.log("hub-recieve-status-updated-dashboard------------on'")
  },
  beforeDestroy() {
    //clean SignalR event
    this.$userHub.$off(
      'hub-recieve-status-updated-dashboard',
      this.updateQueueStatusByhub
    )

    /* eslint-disable no-debugger, no-console */
    console.log("hub-recieve-status-updated-dashboard------------off'")
  },
  methods: {
    async search(pageIndex = 1) {
      this.paginationModel.currentPage = pageIndex
      const { data } = await DashboardsSourcesUpdateService.search({
        pageIndex: this.paginationModel.currentPage,
        pageSize: this.paginationModel.perPage,
      })
      if (data) {
        this.results = [
          ...data.data.map((e) => ({
            ...e,
            inProcess: e.detail?.statusId == loadControlStatus.Running,
          })),
        ]

        this.paginationModel = {
          ...this.paginationModel,
          totalItemCount: data.totalItemCount,
          pageCount: data.pageCount,
          currentPage: data.currentPage,
          count: data.count,
        }
      }
    },
    updateQueueStatusByhub(res) {
      const infoUpdated = res?.respose

      const index = this.results.findIndex((item) => {
        return item.processId == infoUpdated.processId
      })

      if (infoUpdated.detail.statusId == loadControlStatus.Running) {
        this.results[index]['inProcess'] = true

        this.results.forEach((item) => {
          item.existSomeProcessRunning = true
        })
      } else {
        this.setObjectValues(infoUpdated, this.results[index])
        this.results[index]['inProcess'] = false

        this.results.forEach((item) => {
          item.existSomeProcessRunning = false
        })
      }
    },
    async updateHandler(row) {
      DashboardsSourcesUpdateService.update(row.processId)
      this.search(this.paginationModel.currentPage)
    },
    setObjectValues(obj1, obj2) {
      for (const key in obj1) {
        if (key in obj1 && key in obj2) {
          obj2[key] = obj1[key]
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
